import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleAdvancePlainObjectQuery, SaleAdvancePlainObjectQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleAdvancePlainObjectQuery)
@Wrapper(SaleAdvancePlainObjectQueryHandlerBase)
export class SaleAdvancePlainObjectQueryHandler {
    public constructor(
        http: Http
    ) { }
}
